"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationCodeResult = void 0;
var ValidationCodeResult;
(function (ValidationCodeResult) {
    ValidationCodeResult["UNDEFINED"] = "Undefined";
    ValidationCodeResult["VALID"] = "Valid";
    ValidationCodeResult["INVALID"] = "Invalid";
})(ValidationCodeResult || (exports.ValidationCodeResult = ValidationCodeResult = {}));
